import { MarkdownTableCell } from '../extensions/table/types';
import { parseMarkdown } from '../parseMarkdown';
import { IMarkdownConfiguration, RemarkableExtension } from '../types';
import { MarkdownBlock } from './elements/MarkdownBlock';
import { MarkdownDialogBox, TDialogBoxTypes } from './elements/dialogBox';
import { MarkdownHeader } from './elements/header';
import { MarkdownList } from './elements/list';
import { MarkdownParagraph } from './elements/paragraph';
import { MarkdownTable } from './elements/table';
import { MarkdownTableOfContents } from './elements/tableOfContents';

export class MarkdownBuilder {
  protected blocks: MarkdownBlock[] = [];
  protected extensions: RemarkableExtension[] = [];

  setExtensions(extensions: RemarkableExtension[]) {
    this.extensions = extensions;
    return this;
  }

  custom(block: MarkdownBlock) {
    this.blocks.push(block);
  }

  h1(text: string) {
    const heading = new MarkdownHeader(text);

    this.blocks.push(heading);

    return heading;
  }

  h2(text: string) {
    const heading = new MarkdownHeader(text, '##');

    this.blocks.push(heading);

    return heading;
  }

  h3(text: string) {
    const heading = new MarkdownHeader(text, '###');

    this.blocks.push(heading);

    return heading;
  }

  h4(text: string) {
    const heading = new MarkdownHeader(text, '####');

    this.blocks.push(heading);

    return heading;
  }

  h5(text: string) {
    const heading = new MarkdownHeader(text, '#####');

    this.blocks.push(heading);

    return heading;
  }

  h6(text: string) {
    const heading = new MarkdownHeader(text, '######');

    this.blocks.push(heading);

    return heading;
  }

  p(text: string) {
    const p = new MarkdownParagraph(text);

    this.blocks.push(p);

    return p;
  }

  list(sorted = false) {
    const list = new MarkdownList(sorted);

    this.blocks.push(list);

    return list;
  }

  dialogBox(text: string, level: TDialogBoxTypes = 'success') {
    const box = new MarkdownDialogBox(text, level);

    this.blocks.push(box);

    return box;
  }

  table(header: MarkdownTableCell[] = [], rows: MarkdownTableCell[][] = []) {
    const table = new MarkdownTable(header, rows);

    this.blocks.push(table);

    return table;
  }

  /**
   * Este método debería ser llamado una única vez dentro de un documento,
   * agrega la tabla de contenidos la html
   */
  tableOfContents() {
    this.blocks.push(new MarkdownTableOfContents());
  }

  /**
   * Este método recibe un html y le agrega la tabla de contenidos, dentro de
   * un div con id="TableOfCOntents"
   */
  addTableOfContents(tableOfContentsTitle: string, html: string): string {
    return MarkdownTableOfContents.appendTableOfContents(
      tableOfContentsTitle,
      html,
    );
  }

  toMarkdown(): string {
    let markdown = this.blocks
      .map((current) => current.toString())
      .join('\n\n');

    markdown = markdown.replaceAll(/ *\n *\n *\n/g, '\n\n');

    return markdown;
  }

  toHtml(
    options: Pick<
      IMarkdownConfiguration,
      | 'additionalStyles'
      | 'extensions'
      | 'htmlTemplate'
      | 'title'
      | 'tableOfContentsTitle'
    >,
  ): Promise<string> {
    let content = this.toMarkdown();

    if (options?.tableOfContentsTitle)
      content = this.addTableOfContents(options.tableOfContentsTitle, content);

    return parseMarkdown({ ...options, content });
  }
}
